import { TextField } from "@/app/fields";
import type { Errors } from "@/app/useDraft";
import { Field, Input, InputGroup, Select } from "@/ui";

import type { PricingFieldsDraft } from "./pricingDraft";
interface Props<T extends PricingFieldsDraft> {
  currencyReadOnly?: boolean; idPrefix: string; draft: T; errors: Errors<T>; set: <K extends keyof T>(k: K, v: T[K]) => void;
  /** 计费类型被通道锁定时的原因，例如 Telegram 只按送达计（D207 第 6 条）；给了就不能改。 */
  chargeOnLock?: string;
}

/** 售价和通道价格共用目的地、报价、计费类型及生效时间字段（D110、D111）；MCC/MNC 仅手填（D112）。 */
export function PriceFields<T extends PricingFieldsDraft>({ idPrefix, draft, errors, set, currencyReadOnly = false, chargeOnLock }: Props<T>) {
  const id = (suffix: string) => `${idPrefix}-${suffix}`;
  return <>
    <Field label="MCC" required htmlFor={id("mcc")} error={errors.mcc} hint="三位国家码">
      <Input id={id("mcc")} mono value={draft.mcc} invalid={!!errors.mcc} onChange={(e) => { set("mcc", e.target.value); set("mnc", ""); }} />
    </Field>
    <Field label="MNC" htmlFor={id("mnc")} error={errors.mnc} hint="两到三位数字，留空表示全部运营商">
      <Input id={id("mnc")} mono value={draft.mnc} invalid={!!errors.mnc} onChange={(e) => set("mnc", e.target.value)} />
    </Field>
    <Field label="价格" required htmlFor={id("price")} error={errors.price} hint="按拆分后的每段报价">
      <InputGroup addon={draft.currency || "币种"}><Input id={id("price")} mono value={draft.price} invalid={!!errors.price} onChange={(e) => set("price", e.target.value)} /></InputGroup>
    </Field>
    <TextField id={id("currency")} label="币种" required mono readOnly={currencyReadOnly} value={draft.currency} error={errors.currency} onChange={(v) => set("currency", v.toUpperCase())} />
    <Field label="计费类型" required error={errors.charge_on} hint={chargeOnLock}>
      <Select block options={[{ value: "submitted", label: "提交" }, { value: "delivered", label: "送达" }]} value={draft.charge_on} disabled={!!chargeOnLock}
        onChange={(v) => set("charge_on", v as T["charge_on"])} />
    </Field>
    <TextField id={id("from")} label="生效时间" required type="datetime-local" mono value={draft.effective_from} error={errors.effective_from} hint="北京时间" onChange={(v) => set("effective_from", v)} />
  </>;
}
